<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-form ref="partnerForm" v-model="valid" class="width-100">
        <v-flex>
          <h3 class="mb-3">{{ action }} Partner</h3>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Partner Name*"
            required
            v-model="editPartnerObject.name"
            :rules="rules.required"
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-textarea
            label="Expanded Name"
            v-model="editPartnerObject.expanded_name"
          >
          </v-textarea>
        </v-flex>

        <v-flex xs12>
          <v-select
            label="Type"
            required
            :rules="rules.required"
            v-model="editPartnerObject.type"
            :items="[
              { name: 'Partner', id: 'partner' },
              { name: 'Hub', id: 'hub' },
            ]"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Program Data Reporting URL"
            required
            v-model="editPartnerObject.program_reporting_url"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="See My Data URL"
            required
            v-model="editPartnerObject.program_data_url"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-autocomplete
            label="Add and Remove Members"
            :items="ac_results"
            v-model="editPartnerObject.users"
            item-text="display_name"
            item-value="id"
            :loading="usersLoading"
            multiple
            chips
            cache-items
            :search-input.sync="search"
            autocomplete
            class="mt-4"
            hide-selected
            no-data-text="Start typing to search"
            @change="userSelected"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                close
                @input="data.parent.selectItem(data.item)"
                :selected="data.selected"
                class="chip--select-multi"
                :key="data.id"
              >
                {{ data.item.display_name }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="data">
              <template>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.display_name"
                  ></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>

        <v-flex>
          <div v-if="hasErrors" class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                There were issues trying to save this partner. If this continues
                please submit feedback to the Amaze administrator.
              </div>
            </div>
          </div>

          <v-btn
            color="primary"
            class="mx-0"
            @click="savePartner()"
            :disabled="disabled"
            v-if="!submitting"
            >Save</v-btn
          >
          <v-progress-circular v-else indeterminate />
        </v-flex>
      </v-form>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";
export default {
  mixins: [permissionsMixin],
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      usersLoading: false,
      ac_results: [],
      search: "",
      editPartnerObject: {},
      valid: false,
      disabled: false,
      hasErrors: false,
      submitting: false,
      rules: {
        required: [(v) => !!v || "This field is required."]
      }
    };
  },
  computed: {
    action() {
      return this.editPartnerObject.id ? "Edit" : "Add";
    }
  },
  watch: {
    search(val) {
      val && this.queryUsers(val);
    }
  },
  methods: {
    async queryUsers(v) {
      this.usersLoading = true;
      let users = await this.$http.get("users/autocomplete?q=" + v);
      this.ac_results = users.body;
      this.usersLoading = false;
    },
    userSelected(e) {
      this.search = "";
    },
    async savePartner() {
      if (this.$refs.partnerForm.validate()) {
        this.hasErrors = false;
        this.submitting = true;
        this.disabled = true;
        if (this.editPartnerObject.id) {
          await this.$http
            .put(
              "dsec/partners/" + this.editPartnerObject.id,
              this.editPartnerObject
              // eslint-disable-next-line handle-callback-err
            )
            .catch((error) => {
              this.hasErrors = true;
            });
        } else {
          // eslint-disable-next-line handle-callback-err
          await this.$http
            .post("dsec/partners", this.editPartnerObject)
            .catch((error) => {
              this.hasErrors = true;
            });
        }
        this.disabled = false;
        this.submitting = false;

        if (!this.hasErrors) {
          EventBus.$emit("refreshPartners");
          this.$emit("close");
        }
      }
    }
  },
  async mounted() {
    if (this.item.id) {
      let partner = await this.$http.get("dsec/partners/" + this.item.id);
      this.editPartnerObject = partner.body;
      this.ac_results = this.editPartnerObject.users;
    }
  }
};
</script>

<style></style>
